import React from 'react';
import { string } from 'prop-types';

const AngleRight = ({ color = 'fourth-color', fontSize = '10px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_chevron_right ${className}`}
  />
);

AngleRight.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default AngleRight;
